import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Element from './HeaderNavElement';
import LanguageSelector from './LanguageSelector';
export default function Nav(props) {
    return (_jsxs("ul", { className: "mt-16 space-y-6 text-base font-medium text-day-mode-text-primary sm:mt-0 sm:flex sm:space-x-8 sm:space-y-0 sm:whitespace-nowrap", children: [props.links.map((link) => (_jsx(Element, { link: link }, link.title))), _jsx(LanguageSelector, {})] }));
}
